import { createNavioClient } from "@navio-maritime/platform/client";
import { captureAppError } from "./observability";

// F0.2 — cross-project auth (Master Spec §3.5). `authClient` → navio-platform (identity:
// signIn/signOut/session). `dataClient` → the NavioPlan project, transparently exchanging the
// navio JWT for a navioplan-local JWT via the deployed auth-exchange edge function (so RLS via
// auth.uid() works with the navio `sub` preserved). NavioPlan never owns identity.
export const { authClient, dataClient, invalidateExchangedToken } = createNavioClient({
  navioUrl: import.meta.env.VITE_NAVIO_URL,
  navioAnon: import.meta.env.VITE_NAVIO_ANON,
  productUrl: import.meta.env.VITE_PRODUCT_URL,
  productAnon: import.meta.env.VITE_PRODUCT_ANON,
  onTokenExchangeError: (err, ctx) => {
    captureAppError("Token exchange failed", err, { stage: ctx.stage, status: ctx.status });
  },
});
